import React from "react";

const AboutPage = () => {
  return (
    <div className="app-container">
      <main className="main-content">
        <section className="section">
          <h2 className="section-title">PETPANDNCACTDNAOASK : About</h2>

          <div className="content-block">
            <h3>Biography</h3>
            <p>
              It reconstructs audio and visual elements, fusing culture with technology to
              propagate a vision of sovereign digital existence. It creates holistic,
              integrated experiences where sound, sight, and system converge as a single,
              comprehensive work of art.
            </p>

            <h3>Philosophy</h3>
            <p>
              In a world where the digital has become default, the distinction between the
              virtual and the physical begins to dissolve. Digital experiences are no longer
              external events; they have evolved into extensions of human physiology and
              cognitive function, weaving themselves into the fabric of daily life.
            </p>
            <p>
              When multiple algorithms intertwine, they surpass the threshold of human input
              capacity, manifesting as something indistinguishable from the natural world. It
              stands as an expression of this evolution: the moment where computational
              complexity returns to nature itself.
            </p>

            <h3>Origins</h3>
            <p>
              This unique perspective was forged through years of activity across the distinct
              fields of design and blockchain development. The synthesis of aesthetic
              experience and decentralized autonomy forms the foundation of its output.
            </p>

            <h3>Social / Contact</h3>
            <p>
              <a
                href="https://www.instagram.com/petpandncactdnaoask/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram: @petpandncactdnaoask
              </a>
            </p>
            <p>
              <a
                href="https://www.youtube.com/@PETPANDNCACTDNAOASK"
                target="_blank"
                rel="noopener noreferrer"
              >
                Youtube: https://youtube.com/@PETPANDNCACTDNAOASK
              </a>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AboutPage;
